<template>
  <div class="con" :class="{ dark: active2 }">
    <div class="mm">
      <div class="main">
        <a class="left" href="/home.html">
          <img class="a" src="../assets/aem/topLogo.png" alt="" />
        </a>
        <div class="right">
          <ul>
            <li class="animated fadeInDown" :class="page === 'home' ? 'showLine' : ''" style="animation-delay: 0.2s">
              <a href="./home.html">{{ $t(`header.home`) }}</a>
            </li>
            <li class="animated fadeInDown" :class="page === 'about' ? 'showLine' : ''" style="animation-delay: 0.3s">
              <a href="./about.html" target="_self">{{ $t(`header.about`) }}</a>
              <div class="allList">
                <span v-for="(item, index) in $t(`header.aboutList`)" :key="index" :style="{ transitionDelay: `${index * 0.1 + 's'}` }" @click="gotoAbout(index)" @mouseenter.stop="getPic(item.picurl)">{{ item.name }}</span>
              </div>
            </li>
            <li class="animated fadeInDown" :class="page === 'product' ? 'showLine' : ''" style="animation-delay: 0.4s">
              <a href="./product.html" target="_self">{{ $t(`header.product`) }}</a>
              <div class="allList">
                <span v-for="(item, index) in $t(`header.productList`)" :key="index" :style="{ transitionDelay: `${index * 0.1 + 's'}` }" @click="gotoPro(index)" @mouseenter.stop="getPic(item.picurl)">{{ item.name }}</span>
              </div>
            </li>
            <li class="animated fadeInDown" :class="page === 'tz' ? 'showLine' : ''" style="animation-delay: 0.6s" v-if="$i18n.locale === 'zh'">
              <a href="./gover.html" target="_self">投资者关系</a>
              <div class="allList">
                <span v-for="(item, index) in tList" :key="index" :style="{ transitionDelay: `${index * 0.1 + 's'}` }" @click="gotoTz(index)" @mouseenter.stop="getPic(item.picurl)">{{ item }}</span>
              </div>
            </li>
            <li class="animated fadeInDown" :class="page === 'news' ? 'showLine' : ''" style="animation-delay: 0.7s">
              <a href="./news.html?type=1" target="_self">{{ $t("header.news") }}</a>
              <div class="allList">
                <span v-for="(item, index) in $t(`header.newsList`)" :key="index" :style="{ transitionDelay: `${index * 0.1 + 's'}` }" @click="gotoNews(index)" @mouseenter.stop="getPic(item.picurl)">{{ item.name }}</span>
              </div>
            </li>
            <li class="animated fadeInDown" :class="page === 'search' ? 'showLine' : ''" style="animation-delay: 0.7s">
              <a href="./searchCoa.html" target="_self">{{ $t("header.search") }}</a>
              <div class="allList">
                <span v-for="(item, index) in $t(`header.searchList`)" :key="index" :style="{ transitionDelay: `${index * 0.1 + 's'}` }" @click="gotoContact(index)" @mouseenter.stop="getPic(item.picurl)">{{ item.name }}</span>
              </div>
            </li>
            <li class="animated fadeInDown" :class="page === 'service' ? 'showLine' : ''" style="animation-delay: 0.7s">
              <a href="./service.html" target="_self">{{ $t(`header.services`) }}</a>
              <div class="allList">
                <span v-for="(item, index) in cList" :key="index" :style="{ transitionDelay: `${index * 0.1 + 's'}` }" @mouseenter.stop="getPic(item.picurl)">{{ item.name }}</span>
              </div>
            </li>
            <li class="animated fadeInDown phone" style="animation-delay: 0.7s" v-if="$i18n.locale === 'zh'">
              <a href="https://www.youliao.com" target="_blank">
                {{ $t(`header.mall`) }}
              </a>
            </li>
            <li class="animated fadeInDown" :class="page === 'contact' ? 'showLine' : ''" style="animation-delay: 0.7s">
              <a href="javascript:void(0);" @click.prevent="call" target="_self" class="phone">
                <a href="" ref="tels" v-show="false"></a>
                <img :src="`${imageUrl}uploads/content/product/phoneIcon.png`" alt="" class="phoneIcon" />
                <!-- <div>{{ $t(`contact.title`) }}</div> -->
                <div>400-8811-938</div>
              </a>
              <!-- <div class="allList">
                <span v-for="(item, index) in $t(`header.contactList`)" :key="index" :style="{ transitionDelay: `${index * 0.1 + 's'}` }" @click="gotoServiceContact(item)" @mouseenter.stop="getPic(item.picurl)">
                  <div>{{ item.name }}</div>
                  <div v-if="index == 0">400-8811-938</div>
                </span>
              </div> -->
            </li>
            <li class="animated fadeInDown" style="animation-delay: 0.7s" @click="handleEn('en')">
              <a href="javascript:void(0);" target="_blank" @click.prevent="changeLang">{{ $i18n.locale === "zh" ? "English" : "Chinese" }}</a>
            </li>
          </ul>
        </div>
        <div class="choseLan">
          <div class="lan" style="opacity: 0!important;">
            <span>EN</span>
            <span>CN</span>
          </div>
          <div class="num">
            <div class="span1" :class="{ green: obj['currentPrice'] < 0 }" style="margin-right: 0">
              <div style="display: flex;align-items: center;white-space: nowrap;">
                {{ obj["currentPrice"] }}
                <div class="span2" style="display: block;" :class="{ green: obj['rate'] < 0 }">({{ Number(obj["rate"]).toFixed(2) }}%)</div>
              </div>
              <div class="span3">
                股票代码:
                <span style="font-size: 18px">002584</span>
              </div>
            </div>
            <!-- <div style="opacity: 0;pointer-events: none">
              <img src="../assets/aem/shang.png" alt="" />
            </div> -->
            <!--  <div style="margin-right: 0">
              <div class="span2" :class="{'green':obj['increasePrice']<0}">
                <div>{{obj['increasePrice']}}</div>
              </div> 
              <div class="span2" style="display: block;white-space: nowrap;" :class="{'green':obj['rate']<0}"> ({{obj['increasePrice']}}，{{Number(obj['rate']).toFixed(2)}}%)</div>
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <div class="top animated fadeInDown">
      <a href="/index.html" class="l1">
        <img class="a" src="../assets/aem/topLogo.png" alt="" />
      </a>
      <div class="mNav" @click="menuSwitch" :class="{ active: menuShow }">
        <span class="burger"></span>
        <span class="burger"></span>
        <span class="burger"></span>
      </div>
    </div>
  </div>
</template>

<script>
import Scrollbar from "smooth-scrollbar";
import HomeService from "@/services/HomeService";
import global from "@/util/global";

export default {
  name: "first",
  data() {
    return {
      imageUrl: global.imageUrl,
      search: "",
      radio: "试剂",
      obj: {},
      src: "",
      timein: null,
      timeout: null,
      changePic: false,
      pText: "",
      // aList: [],
      pList: [],
      tList: ["公司治理", "信息披露", "定期报告", "投资者保护", "投资者互动平台", "投资者联系方式"],
      nList: [],
      cList: [],
      menuShow: false,
      active2: false,
      scrollbar: "",
      top: "",
    };
  },
  props: ["page"],
  // watch: {
  //     $route: 'getScrollbar'
  // },
  mounted() {
    // this.aList = this.$t(`header.aboutList`);
    // this.pList=JSON.parse(localStorage.getItem('class_2'))
    // this.tList=JSON.parse(localStorage.getItem('class_3'))
    // this.nList=JSON.parse(localStorage.getItem('class_4'))
    // this.cList=JSON.parse(localStorage.getItem('class_5'))
    // this.src=this.aList[0].picurl
    this.$nextTick(() => {
      this.getScrollbar();
      this.init();
      this.getNumber();
    });
    // console.log(this.page, 12312)
  },
  methods: {
    changeLang() {
      const lang = this.$i18n.locale === "zh" ? "en" : "zh";
      sessionStorage.setItem("lang", lang);
      // console.log(window.location, 12345555)
      this.$i18n.locale = lang;
      window.open(`./home.html`, "_self");
      // location.reload();
    },
    handleEn(p) {
      this.page = p;
    },


    async getNumber() {
      const { data } = await HomeService.getXiLongStock();
      this.obj = data;
    },
    getPic(url) {
      this.src = url;
    },
    init() {
      let _this = this;
      $("#menu")
        .find("span")
        .hover(
          function() {
            this.time = setTimeout(() => {
              _this.picAnimate();
            }, 500);
          },
          function() {
            clearTimeout(this.time);
          }
        );
    },
    picAnimate() {
      $("#pic").removeClass("changePic");
      setTimeout(() => {
        $("#pic").addClass("changePic");
      }, 100);
    },
    gotoNews(n) {
      if (n === 0) {
        window.open("./news.html?type=1", "_self");
      } else if (n === 1) {
        window.open("./news.html?type=2", "_self");
      } else if (n === 3) {
        window.open("./brand.html", "_self");
      } else {
        window.open("./news.html?type=3", "_self");
      }
    },
    gotoAbout(n) {
      if (n === 0) {
        window.open("./about.html", "_self");
      } else if (n === 1) {
        window.open("./history.html", "_self");
      } else if (n === 2) {
        window.open("./honor.html", "_self");
      } else if (n === 3) {
        window.open("./join.html", "_self");
      }
      // else {
      //   window.open("./join.html", "_self");
      // }
    },
    gotoTz(n) {
      if (n === 0) {
        window.open("./gover.html", "_self");
      } else if (n === 1) {
        window.open("http://www.cninfo.com.cn/new/disclosure/stock?stockCode=002584&orgId=9900019958#latestAnnouncement", "_blank", "noopener noreferrer");
      } else if (n === 2) {
        window.open("http://www.cninfo.com.cn/new/disclosure/stock?stockCode=002584&orgId=9900019958#periodicReports", "_blank", "noreferrer");
      } else if (n === 3) {
        window.open("./protect.html", "_self");
      } else if (n === 4) {
        window.open("http://ir.p5w.net/c/002584.shtml", "_blank");
      } else if (n === 5) {
        window.open("./onLine.html", "_self");
      }
    },
    gotoContact(n) {
      let url = ``;
      switch (n) {
        case 0:
          url = `./searchCoa.html`;
          break;
        case 1:
          url = `./searchMsds.html`;
          break;
        case 2:
          url = `./searchSafetyLabel.html`;
          break;
        case 3:
          url = `./searchTds.html`;
          break;
      }
      window.open(url, "_self");
    },
    gotoServiceContact({ url }) {
      url && window.open(url, "_self");
    },
    gotoPro(n) {
      // 产品
      if (n === 0) {
        window.open("./product.html", "_self");
      } else if (n === 1) {
        window.open("./material.html", "_self");
      } 
      // else if (n === 2) {
      //   window.open("./daily.html", "_self");
      // }
      /*else if (n === 3) {
        window.open("./health.html", "_self");
      } else if (n === 4) {
        window.open("./brand.html", "_self");
      } else if (n === 5) {
        window.open("./internet.html", "_self");
      }*/
    },
    menuSwitch() {
      this.menuShow = !this.menuShow;
      this.$emit("menushow", this.menuShow);
    },
    change(n) {
      const link = `/about.html?index=${n}`;
      window.open(link, "_self");
    },
    aStyle(n) {
      return { transitionDelay: n * 0.1 + "s" };
    },
    addClass(n) {
      this.pText = n;
    },
    scrollHeader(scrollTop) {
      this.active2 = scrollTop > 200 ? true : false;
    },
    getScrollbar() {
      this.$nextTick(() => {
        this.scrollbar = Scrollbar.get(document.getElementById("scroller-wrapper"));
        this.active2 = false;
        let scrollHeader = this.scrollHeader;
        if (this.scrollbar) {
          this.scrollbar.addListener(status => {
            scrollHeader(status.offset.y);
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.con {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  transition: all 0.8s;

  .mm {
    width: 100%;
    transition: all 500ms;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    padding-top: 20px;
    background-color: rgba(41, 44, 45, 0.8);
    .main {
      width: 80%;
      display: flex;
      flex-direction: row;
      transition: all 500ms;
      margin: 0 auto;
      align-items: center;
      justify-content: space-between;

      .left {
        display: inline-block;
        width: 150px;
        height: 37px;
        position: relative;
        transition: all 500ms;
        overflow: hidden;
        img {
          position: absolute;
          left: -100%;
          top: 0;
          height: 100%;
          width: 100%;
          animation: show 1s linear forwards;
          opacity: 0;
          object-fit: contain;
        }

        @keyframes show {
          from {
            left: -100%;
            opacity: 0;
          }
          to {
            left: 0;
            opacity: 1;
          }
        }
      }

      .right {
        width: 75%;
        ul {
          margin-left: 7%;
          list-style: none;
          display: flex;
          flex-direction: row;
          // justify-content: center;
          align-items: center;
          // width: 100%;
          justify-content: space-between;

          li {
            position: relative;
            cursor: pointer;
            // margin: 0 2%;

            a {
              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
              font-family: "SOURCEHANSANSCN-LIGHT";
              list-style: none;
              margin: 0;
              border: 0;
              outline: none;
              cursor: pointer;
              transition: 600ms;
              text-decoration: none;
              position: relative;
              // display: block;
              display: flex;
              align-items: center;
              height: 70px;
              // line-height: 70px;
              color: white;
              text-align: center;

              &::after {
                content: "";
                display: inline-block;
                width: 0;
                height: 1px;
                background-color: white;
                position: absolute;
                left: 0;
                bottom: -1px;
                transition: all 500ms;
              }
            }
            .allList {
              visibility: hidden;
              opacity: 0;
              transition: all 500ms;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              position: absolute;
              background-color: rgba(41, 44, 45, 0.8);
              padding-bottom: 10px;
              span {
                display: inline-block;
                margin-top: 10px;
                color: #fff;
                padding-left: 10px;
                cursor: pointer;
                transition: all 500ms;
                font-family: "SOURCEHANSANSCN-REGULAR";
                position: relative;
                opacity: 0; 
                transform: translateY(30px);
                width: 120px;
                &::before {
                  content: "";
                  display: inline-block;
                  width: 0;
                  transition: all 500ms;
                  height: 1px;
                  background: #00748d;
                  // background: #fff;
                  opacity: 0.5;
                  position: absolute;
                  left: -116px;
                  top: 10px;
                }
                &:hover {
                  color: rgba(0, 116, 141, 1);
                  &::before {
                    width: 100px;
                  }
                }
              }
            }

            &:hover {
              .allList {
                visibility: visible;
                opacity: 1;
                transform: rotateY(0);
                span {
                  opacity: 1;
                  transform: translateY(0);
                  color: #fff;
                }
              }
              a {
                &::after {
                  width: 100%;
                }
              }
            }
          }

          .showLine {
            a {
              font-weight: bolder;

              &::after {
                width: 100%;
              }
            }
          }
        }
        .phone {
          display: flex;
          align-items: center;
          color: #fff;
          .phoneIcon {
            width: 18px;
            height: 18px;
            margin-right: 3px;
          }
        }
      }

      .choseLan {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 12%;

        .lan {
          span {
            color: #999999;
            font-family: "DINEngschriftStd";
            display: inline-block;
            margin: 0 10px;
            cursor: pointer;
            transition: all 500ms;

            &:hover {
              color: white;
            }
          }

          span:nth-child(1) {
            position: relative;

            &::after {
              right: -10px;
              top: 4px;
              width: 1px;
              height: 10px;
              background: #999999;
              content: "";
              display: inline-block;
              position: absolute;
            }
          }
        }

        .num {
          display: flex;
          flex-direction: row;
          align-items: center;
          .span3 {
            color: #fe0000;
            font-size: 14px;
            font-family: "DINEngschriftStd";
            white-space: nowrap;
          }
          .span1 {
            color: #fe0000;
            font-size: 32px;
            font-family: "DINEngschriftStd";
          }

          div {
            margin: 0 20px 0 8px;
          }

          .span2 {
            color: #fe0000;
            font-family: "DINEngschriftStd";
            font-size: 20px;
          }
        }
      }
    }
  }

  .top {
    display: none;
  }

  @keyframes transition1 {
    0% {
      transform: translate(-100px, -100px);
      opacity: 0;
    }
    100% {
      transform: translate(0, 0);
      opacity: 1;
    }
  }
  @keyframes transition2 {
    0% {
      transform: translate(100px, -100px);
      opacity: 0;
    }
    100% {
      transform: translate(0, 0);
      opacity: 1;
    }
  }
  @keyframes polygon {
    0% {
      clip-path: polygon(0% 0%, 0% 100%, 0% 100%, 0% 0%);
    }
    100% {
      clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%);
    }
  }
  @media screen and (min-width: 2200px) {
    .main {
      ul {
        width: 60%;
      }
    }
  }
  @media screen and (max-width: 1570px) {
    .mm {
      .main {
        width: 90%;
        margin-left: 5%;

        .right {
          ul {
            margin-left: 7%;
            display: flex;
            justify-content: space-between;
            // li{
            //   margin: 0px 2%;
            // }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1100px) {
    .mm {
      display: none;
    }
    .top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      transition: all 0.8s;
      background-color: rgba(0, 0, 0, 0.5);

      a {
        display: inline-block;
        padding: 10px 0;
        width: 100%;

        img {
          width: 50%;
          height: 32px;
          margin-left: 25%;
          object-fit: contain;
        }
      }
    }
    .mNav {
      display: block;
      transition: 0.8s;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: 60px;
    }
    .mNav .burger {
      width: 32px;
      height: 3px;
      background-color: white;
      position: absolute;
      top: 15px;
      left: 50%;
      margin: 0px 0px 0px -16px;
      transform-origin: center;
      transition: 0.8s;
    }
    .mNav .burger:nth-of-type(2) {
      top: 25px;
    }
    .mNav .burger:nth-of-type(3) {
      top: 35px;
    }
    .mNav.active {
      /*background-color:#2bad38;*/
    }
    .mNav.active .burger {
      background-color: white;
    }
    .mNav.active .burger:nth-of-type(1) {
      top: 25px;
      transform: rotate(225deg);
    }
    .mNav.active .burger:nth-of-type(2) {
      left: -100%;
      opacity: 0;
    }
    .mNav.active .burger:nth-of-type(3) {
      top: 25px;
      transform: rotate(-225deg);
    }
  }
}

.dark {
  background-color: rgba(41, 44, 45, 0.8);
  transform: translateY(-20px);
  .search {
    height: calc(100vh + 20px);
  }
  @media screen and (max-width: 1199px) {
    transform: translateY(0);
  }
}
</style>
<style>
.green {
  color: green !important;
}
</style>
